export default __webpack_public_path__ + "static/media/meera.ed0d54bf.png";